import Vue from 'vue';
import Vuex from 'vuex'
import user from './modules/user'
import VueXAlong from 'vuex-along'
//使用

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user
  },
  plugins: [VueXAlong({
    local: {
      list: [],
      isFilter: true,
    }
  })]
})



// WEBPACK FOOTER //
// ./src/store/index.js